import * as React from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../../../router/Routes';
import ContainerTemplate from '../../../../widgets/template/Container';
import ActividadesExtrasView from './ActividadesExtrasView';

const ActividadesExtrasModule = () => {
  const loginStore = Redux.useSelector((state) => state.login);

  const admin = [ROUTES.controlEstudios];
  const teacher = [ROUTES.academico];

  return (
    <ContainerTemplate
      active={ROUTES.actividadesExtras}
      routes={loginStore.isAdmin ? admin : teacher}
    >
      <ActividadesExtrasView />
    </ContainerTemplate>
  );
};

export default ActividadesExtrasModule;
